"use client"

import { Transition } from "@headlessui/react"
import React, { ReactNode, Ref } from "react"
import { Message, MessageAuthor } from "@graphql/assistants/graphql"
import { StyledText } from "domains/layout/components/StyledText"
import { clsx } from "clsx"

export function ChatMessage({ footer, message }: { footer?: ReactNode; message: Message }) {
    return (
        <Transition
            appear={true}
            show={true}
            enter="transition-opacity duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
        >
            <BasicChatMessage footer={footer} alignment={message.author === MessageAuthor.Human ? "right" : "left"}>
                <StyledText>{message.content}</StyledText>
            </BasicChatMessage>
        </Transition>
    )
}

const styles = {
    alignment: {
        left: "justify-start",
        right: "justify-end",
    },
    bgColor: {
        left: "bg-gray-200 text-gray-900",
        right: "bg-primary-700 text-white",
    },
}

export function BasicChatMessage({
    alignment,
    children,
    ref,
    footer,
}: {
    alignment: keyof typeof styles.alignment
    children: ReactNode
    ref?: Ref<HTMLDivElement>
    footer?: ReactNode
}) {
    return (
        <div ref={ref} className={`flex ${styles.alignment[alignment]} my-2 ease-in`}>
            <div className={clsx(`max-w-[85%] rounded-lg ${styles.bgColor[alignment]}`, footer ? "pt-3 pb-2" : "py-3")}>
                {children}
                {footer && (
                    <div className={clsx("mt-2 border-t border-white/50", styles.bgColor[alignment])}>{footer}</div>
                )}
            </div>
        </div>
    )
}
